import React, { useState, useEffect } from "react";

import { GetReportFT } from "./../../api/full_time";
import { GetAcativeRestaurants } from "./../../api/restaurant";

const ReportFT = ({ token }) => {
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [restaurantId, setRestaurantId] = useState(0);
  const [restaurantList, setRestaurantList] = useState([]);
  const [data, setData] = useState([]);
  const [FTRestaurant, setFTRestaurant] = useState();

  const loading = async () => {
    try {
      const restsaurants = await GetAcativeRestaurants(token);
      setRestaurantList(restsaurants);
      let rests = {};
      for (let r of restsaurants) {
        rests[r.id] = r;
      }
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    loading();
  }, [token]);

  async function donwloadRepost() {
    const response = await GetReportFT(token, startDate, endDate, restaurantId);

    renderTable(response);
  }

  function renderTable(data) {
    let dates = [];
    let tb = [];
    let thead = [<th className="text-center">Сотрудник</th>];
    for (let ft of data) {
      console.log(ft.start_date);
      if (!dates.includes(ft.start_date)) {
        dates.push(ft.start_date);
      }
    }
    let users = {};
    for (let ft of data) {
      if (!users[ft.user_id]) {
        users[ft.user_id] = [];
      }
      users[ft.user_id].push(ft);
    }
    let restaurants = {};
    for (let ft of data) {
      if (!restaurants[ft.restaurant_id]) {
        restaurants[ft.restaurant_id] = [];
      }
      restaurants[ft.restaurant_id].push(ft);
    }
    console.log(restaurants);

    let tbRest = [];
    for (let rest of Object.values(restaurants)) {
      tbRest.push(
        <tr>
          <td>{rest[0].restaurant_name}</td>
          <td>{rest.length}</td>
        </tr>
      );
    }

    for (let user of Object.values(users)) {
      let row = [
        <td className="text-center">
          {user[0].user_surname} {user[0].user_name}
        </td>,
      ];
      let haveFT = false;
      for (let d of dates) {
        haveFT = false;
        for (let ts of user) {
          if (ts.start_date == d) {
            row.push(<td className="text-center">{ts.restaurant_name}</td>);
            haveFT = true;
            break;
          }
        }
        if (!haveFT) {
          row.push(<td className="text-center">---</td>);
        }
      }
      tb.push(<tr>{row}</tr>);
    }

    for (let d of dates) {
      thead.push(<th className="text-center">{d}</th>);
    }

    setData(
      <table className="table table-bordered">
        <thead>
          <tr>{thead}</tr>
        </thead>
        <tbody>{tb}</tbody>
      </table>
    );

    setFTRestaurant(
      <table className="table table-bordered">
        <thead>
          <tr>
            <th>Ресторан</th>
            <th>Кол-во</th>
          </tr>
        </thead>
        <tbody>{tbRest}</tbody>
      </table>
    );
  }

  return (
    <div className="container">
      <div className="row">
        <div className="col-md-12" style={{ marginTop: "1%" }}>
          <h1 className="text-center">Отчет по FT</h1>
        </div>

        <div className="col-md-3 text-center" style={{ marginTop: "3%" }}>
          {/* <div className="mb-3"> */}
          <label className="form-label">Начало периода</label>
          <input
            className="form-control"
            type="date"
            name=""
            id=""
            onChange={(e) => setStartDate(e.target.value)}
            value={startDate}
          />
          {/* </div> */}
        </div>
        <div className="col-md-3 text-center" style={{ marginTop: "3%" }}>
          <label className="form-label">Конец периода</label>
          <input
            className="form-control"
            type="date"
            name=""
            id=""
            onChange={(e) => setEndDate(e.target.value)}
            value={endDate}
          />
        </div>
        <div className="col-md-3 text-center" style={{ marginTop: "3%" }}>
          <label className="form-label">Ресторан</label>
          <select
            className="form-select"
            name=""
            id=""
            value={restaurantId}
            onChange={(e) => setRestaurantId(e.target.value)}
          >
            <option value="0">Все</option>
            {restaurantList.map((rest) => (
              <option value={rest.id} key={rest.id}>
                {rest.name}
              </option>
            ))}
          </select>
        </div>
        <div className="col-md-3" style={{ marginTop: "5.8%" }}>
          <button className="btn" onClick={donwloadRepost}>
            Выгрузить
          </button>
        </div>
      </div>
      <div className="row" style={{ marginTop: "5%" }}>
        {data}
      </div>
      <div className="row" style={{ marginTop: "5%" }}>
        {FTRestaurant}
      </div>
    </div>
  );
};

export default ReportFT;
